<script lang="ts">
  // Props and state management
  export let metaData: any;
</script>

<div class="top-section">
  {#if metaData}
    <div class="col-lg-12">
      {@html metaData}
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/vars';
  .top-section {
    flex-direction: column;
    width: auto;
    @include desktop-max-width {
      &:last-child {
        background: none;
        border-top: solid 1px $secondary-gray-01;
      }
    }
    .app-button-container {
      padding: 0 0 1.5rem;
      // border-bottom: 0.1rem solid $color-alabaster-gray;
      overflow-y: hidden;

      @media (max-width: 992px) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
    .app-button {
      display: flex;
      @media (min-width: 576px) {
        margin-top: 0px;
      }
      @media (min-width: 992px) {
        margin-top: -50px;
      }
    }
  }

  :global {
    .we-accept-container {
      background-color: $neutral-dark-01;
      margin: 0 5px;
    }
    .we-accept {
      @include desktop-max-width {
        border-top: 0 !important;
        margin: 0 !important;
      }
    }
  }

  @media screen and (max-width: 991px) {
    .top-section {
      margin-left: 0;
      margin-right: 0;

      .app-button-container {
        border: none;

        .top-row {
          max-width: 34.5rem;
        }
      }
    }
  }
</style>
